import { motion } from "framer-motion";
import { YOURHOMES_SERVICES } from "@/lib/content";
import { fadeUp, stagger } from "@/lib/motion";

export default function YourHomes() {
  return (
    <section
      id="yourhomes"
      data-testid="yourhomes-section"
      className="relative bg-ink-950 py-28 md:py-40 border-t border-ivory/[0.06]"
    >
      <div className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={stagger}
          className="grid grid-cols-12 gap-6 md:gap-12"
        >
          <motion.div variants={fadeUp} className="col-span-12 md:col-span-5">
            <div className="font-mono-caps text-[10px] text-copper mb-6">
              <span className="mr-3">§ 04</span> YourHomes · Advisory
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-ivory">
              Real-estate,<br />
              <span className="italic text-copper">read carefully.</span>
            </h2>
            <div className="mt-10 max-w-md space-y-5 text-ivory/70 leading-relaxed">
              <p>
                Through <span className="text-ivory">YourHomes</span>, I advise homebuyers,
                investors, HNIs and NRIs seeking carefully selected real-estate opportunities in
                Mumbai and other key Indian markets.
              </p>
              <p>
                No pressure calls, no site-visit theatre — just honest positioning, hard numbers
                and a filter tuned for long-term value.
              </p>
            </div>
            <a
              href="#contact"
              data-testid="yourhomes-cta"
              className="mt-10 inline-flex items-center gap-3 text-ivory hover:text-copper font-mono-caps text-[11px] link-underline transition-colors duration-300"
            >
              Book a discovery call
              <span className="text-copper">→</span>
            </a>
          </motion.div>

          <motion.div variants={fadeUp} className="col-span-12 md:col-span-7">
            <ul className="grid grid-cols-1 sm:grid-cols-2 border-t border-ivory/[0.06]">
              {YOURHOMES_SERVICES.map((s, i) => (
                <li
                  key={s.k}
                  className={`group relative p-6 md:p-8 border-b border-ivory/[0.06] ${
                    i % 2 === 0 ? "sm:border-r sm:border-ivory/[0.06]" : ""
                  }`}
                  data-testid={`yourhomes-service-${s.k}`}
                >
                  <div className="font-mono text-copper text-xs mb-4">{s.k}</div>
                  <h3 className="font-serif text-2xl md:text-3xl text-ivory leading-tight group-hover:text-copper transition-colors duration-500">
                    {s.t}
                  </h3>
                  <p className="mt-3 text-ivory/60 leading-relaxed text-sm">{s.d}</p>
                  <span className="pointer-events-none absolute inset-0 border border-transparent group-hover:border-copper/20 transition-colors" />
                </li>
              ))}
            </ul>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
